if (!process.env.VUE_APP_CAPTCHA_SITEKEY) {
    console.warn('Env variable VUE_APP_CAPTCHA_SITEKEY is missing. Please add to the environment file for captcha to work properly.')
}
